import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { page as pageIndex } from '../../globals'
import ExportButtons from '../ExportButtons/ExportButtons'
import DropdownField from '../FormComponents/DropdownField/DropdownField'
import TabsWrapper from '../ManagementTools/components/TabsWrapper'
import STSComponent from '../STSComponent/STSComponent'
import CurrentYearLine from './components/CurrentYearLine'
import StateBreakdown from './components/StateBreakdown'
import SubjectBreakdown from './components/SubjectBreakDown'
import SummaryTracking from './components/SummaryTracking'
import { constants } from './constants'
import './css/ManagementTrackingStats.scss'

class ManagementTrackingStats extends STSComponent {
  returnNodes = (type) => {
    return <React.Fragment>
      <CurrentYearLine date="7/24/2018" />
      <SummaryTracking
        title={constants.nodesData[type].summaryTracking}
        tableSigns={constants.summaryTracking[type]}
      />
      <SubjectBreakdown field={type} title={constants.nodesData[type].subjectBreakdown} />
      <StateBreakdown title={constants.nodesData[type].stateBreakdown} field={type} />
    </React.Fragment>
  }

  render () {
    const { trackData } = this.props
    return <div className="tracking-stats-wrapper">
      <div className="d-flex justify-content-between">
        <ExportButtons showOnlyButtons />
        <div className="archived-year-wrap">
          <DropdownField
            id="archivedYear"
            location={{ page: pageIndex.dashboard, field: 'archivedYear', section: 'trackingStats' }}
            options={[]}
            value={trackData.archivedYear.radio.archivedYear}
            placeholder="Archived Year"
            // updateData={updateData}
          />
        </div>
      </div>
      <TabsWrapper
        legis={this.returnNodes('legis')}
        regs={this.returnNodes('regs')}
        local={this.returnNodes('local')}
      />
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object
  }
}

export default connect(state => ({
  trackData: state.trackingStats.formDataValue.D
}), {})(ManagementTrackingStats)



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/ManagementTrackingStats.js